import { render } from "./EmailTemplateModal.vue?vue&type=template&id=7edb9d8b&scoped=true"
import script from "./EmailTemplateModal.vue?vue&type=script&lang=js"
export * from "./EmailTemplateModal.vue?vue&type=script&lang=js"

import "./EmailTemplateModal.vue?vue&type=style&index=0&id=7edb9d8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edb9d8b"]])

export default __exports__